import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getErrorCodesMap } from './getErrorCodesMap';
export class CommonErrorsMapState {
  constructor(params) {
    _defineProperty(this, "translations", void 0);
    _defineProperty(this, "errorMonitor", void 0);
    _defineProperty(this, "webWindow", void 0);
    _defineProperty(this, "getErrorCodesMap", void 0);
    _defineProperty(this, "_initPromise", void 0);
    _defineProperty(this, "commonErrors", void 0);
    this.translations = params.translations;
    this.errorMonitor = params.errorMonitor;
    this.webWindow = params.webWindow;
    this.getErrorCodesMap = params.getErrorCodesMap ?? getErrorCodesMap;
    this._initPromise = this._init();
  }
  async getInitPromise() {
    const error = await this._initPromise;
    if (error) {
      throw error;
    }
  }
  async _init() {
    try {
      const {
        setCommonErrors
      } = await this.getErrorCodesMap();
      await setCommonErrors(this);
      return null;
    } catch (e) {
      return e;
    }
  }
}
//# sourceMappingURL=CommonErrorsMapState.js.map